/*
 * Project: BookingEngine
 * Module: components/booking/rooms/RoomList.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setPromoCode } from 'bookingform';
import moment from 'moment';
import {
  BOOKING_STEP,
  buildAvailUrl,
  clearRoomSelection,
  sendAvailShareEmail,
  sendGTMEvents,
  setStep,
  DEVICES,
} from '../../../actions/Booking';
import { roomDetailEvent, viewItemListEvent } from '../../../events/Room';
import { MULTIPLE_ROOMS } from '../../../constants';
//import LongStayBanner from './LongStay';
import RoomFilter from './RoomFilter';
//import RoomTile from './RoomTile';
import RoomListTwoRooms from './RoomListTwoRooms';
import ViewingHotel from './ViewingHotel';
import ShareWithOthers from '../../share/ShareWithOthers';
import HotelShareCart from '../hotels/HotelShareCart';
import { setShowLogin, getMemberInfo } from '../../../actions/Loyalty';
import PromoCodeDetail from './PromoCodeDetail';
import DsRoomModal from './modal/RoomModal';
import '../../../static/less/pages/room_selection.less';
//import ClaimPopup from '../../loyalty/ClaimPopup';
import { showLoyaltyClaimPopup, showLoyaltyRedeem } from '../../../utils';
import ReservationDetailsBlock from './ReservationDetailsBlock';
//import LoyaltyLoginBlock from './LoyaltyLoginBlock';
//import BoardDetailsBlock from './BoardDetailsBlock';
//import HotelCardBlock from './HotelCardBlock';
import withNavigate from '../../../withNavigate'; // Importa el HOC
import { selectCurrentRoomText } from '../utils';
import EditModeExit from '../edit-bookings/EditModeExit';
import BannerSandos4U from '../../loyalty/BannerSandos4U';

class RoomList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRoomCodeDetails: false, // code of the room for which we want to open the Pop-up
      formatRoomDetails: 'full',
      hasInvalidPromocode: false,
      promocodeApplied: null,
      promocodeDescription: null,
    };

    this.buildAvailLink = this.buildAvailLink.bind(this);
    this.onToggleRoomDetails = this.onToggleRoomDetails.bind(this);
    this.sendRoomDetailGA = this.sendRoomDetailGA.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const { hotel } = this.props;
    if (!hotel) {
      this.props.navigate('/');
    }
    // We want to reset the room status
    this.props.dispatch(setStep(BOOKING_STEP.CHOOSE));
    this.props.dispatch(clearRoomSelection(true)); // true to send "emptyCartEvent" (as the rooms are getting cleared)
    this.checkIsValidPromoCode();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react/no-string-refs
    jQuery(this.refs.RoomList).addClass('in');

    // Enviar a gtm el evento view_item_list
    this.sendRoomsGA();
    if (showLoyaltyClaimPopup() && this.props.isLoyaltyUserLoggedIn === false
      && this.props.isEditingBooking === false) {
      this.props.dispatch(setShowLogin(true));
    }
    if (this.props.agentCode !== '') {
      // Cuando es un agente y agentSell es false, es decir, cuando la reserva es para sí mismo
      // logeamos al agente en loyalty con la siguiente línea para que pueda usar sus coins.
      // También logeamos al agente en loyalty cuando agentSell es true ya que necesitamos saber su
      //saNetRatePercentage para poder darle a elegir qué tipo de tarifa usar, neta o pública
      this.checkMember(this.props.agentCode, this.props.hotel.code);
    }
  }

  async checkMember(email, hotel_code) {
    const results = await this.props.dispatch(getMemberInfo({
      email,
      callcenter_email: 'test@example.com',
      hotel_code,
    }));
    if (results) {
      // eslint-disable-next-line no-unused-vars
      const { info } = results;
    }
  }

  sendRoomsGA() {
    const { hotel, currentRoomId } = this.props;
    if (!hotel || !hotel.rooms) {
      return;
    }
    const allRooms = hotel.rooms[currentRoomId];
    const event = viewItemListEvent({
      rooms: allRooms,
    });
    this.props.dispatch(sendGTMEvents([event]));
  }

  checkIsValidPromoCode() {
    let appliedOnSomeRoom = false;
    const { hotel, currentRoomId, promoCode } = this.props;
    if (!promoCode || !hotel || !hotel.rooms) {
      // If we have not promo code, is not necessary to continue...
      return;
    }
    const allRooms = hotel.rooms;
    // eslint-disable-next-line no-prototype-builtins
    const currentRoom = allRooms.hasOwnProperty(currentRoomId) ? hotel.rooms[currentRoomId] : null;
    if (currentRoom) {
      currentRoom.forEach((room) => {
        const rate = room.rates[0];
        if (rate && rate.boards.length && rate.boards[0].promocode_has_applied) {
          appliedOnSomeRoom = true;
          this.setState({ promocodeApplied: rate.boards[0].promocode_applied });
          this.setState({ promocodeDescription: rate.boards[0].promocode_description });
        }
      });
    }

    if (!appliedOnSomeRoom) {
      this.setState({ hasInvalidPromocode: true });
      this.props.dispatch(setPromoCode(null));
    }
  }

  sendRoomDetailGA(room) {
    const {
      hotel, lastRequestedInfo, userCurrency, lang,
    } = this.props;
    const event = roomDetailEvent({
      hotel,
      room,
      nights: lastRequestedInfo.nights,
      lang,
      userCurrency,
    });
    this.props.dispatch(sendGTMEvents([event]));
  }

  onToggleRoomDetails(room, format) {
    if (room) {
      this.sendRoomDetailGA(room);
    }
    if (format) {
      this.setState({ formatRoomDetails: format });
    }
    this.setState({ showRoomCodeDetails: room ? room.code : false });
  }

  onShareAvailability = (url, emails) => {
    const { hotel, lastRequestedInfo, distributions } = this.props;
    const dates = { checkin: lastRequestedInfo.checkin, checkout: lastRequestedInfo.checkout };
    return this.props.dispatch(sendAvailShareEmail(
      url, emails, hotel.code, dates, lastRequestedInfo.nights, distributions,
    ));
  };

  buildAvailLink() {
    const availLink = this.props.dispatch(buildAvailUrl());
    return Promise.resolve(availLink);
  }

  filterByCategories(rooms) {
    const categoryCode = this.props.filterCategory.code;
    const filteredRooms = rooms.filter((room) => {
      const roomCategory = room.category ? `cat_${room.category.pk}` : null; // The value as it's on filterCategory
      return roomCategory === categoryCode;
    });
    // If length is Zero, we assume the category selected is "cat_all".
    return filteredRooms.length > 0 ? filteredRooms : rooms;
  }

  filterAndSortRooms(rooms) {
    const hasCategories = this.props.filterCategory;
    const sortableRooms = hasCategories ? this.filterByCategories(rooms) : rooms.slice(0); // clone
    const { reverse } = this.props.filterOrder;
    const isTriptease = this.props.origin === 'TRIPTEASE';

    const sortMethod = (roomsToOrder) => roomsToOrder.sort((roomA, roomB) => {
      if (isTriptease) {
        // Para TRIPTEASE: solo ordenar por precio y nombre
        const priceCheck = roomA.price_from - roomB.price_from;
        if (priceCheck !== 0) {
          return reverse ? -priceCheck : priceCheck;
        }
        // Default, check for name.
        return roomA.name.localeCompare(roomB.name);
      }
      // si no es triptease se ordena como normalmente se ordenan los cuartos:
      // Sort method from highest priority to low priority terms.
      // 1. Promocode aplicado
      // Check for applied Promo Code.
      const roomAPromoCodeApplied = roomA.rates[0].boards[0].promocode_has_applied;
      const roomBPromoCodeApplied = roomB.rates[0].boards[0].promocode_has_applied;
      const promoCodeCheck = roomBPromoCodeApplied - roomAPromoCodeApplied;
      if (promoCodeCheck !== 0) {
        return promoCodeCheck;
      }
      // 2. Best Value
      // Check for recommended room.
      const recommendedCheck = roomB.best_value - roomA.best_value;
      if (recommendedCheck !== 0) {
        return recommendedCheck;
      }
      // 3. Orden de ocupación, viene desde el backend relacionado a hotel occupancy order
      const orderA = roomA.order ?? Infinity;
      const orderB = roomB.order ?? Infinity;
      const occupancyOrderCheck = orderA - orderB;
      if (occupancyOrderCheck !== 0) {
        return occupancyOrderCheck;
      }
      // 4. Precio
      // Check for best price.
      const priceCheck = roomA.price_from - roomB.price_from;
      if (priceCheck !== 0) {
        return reverse ? -priceCheck : priceCheck;
      }
      // 5. Nombre
      // Default, check for name.
      return roomA.name.localeCompare(roomB.name);
    });

    return sortMethod(sortableRooms);
  }

  showSelectedRoomDetailsModal(rooms) {
    const { formatRoomDetails } = this.state;

    const room = rooms.find((r) => r.code === this.state.showRoomCodeDetails);
    if (!formatRoomDetails || !room) {
      return null;
    }
    return (
      <DsRoomModal onClose={() => this.onToggleRoomDetails(null)} room={room} modalContent={formatRoomDetails} />
    );
  }

  renderRoomTiles(rooms) {
    const { hotel, distributions, userCurrency } = this.props;
    /*if (distributions.length === 1) {
      return (
        <div className="room-card-list">
          {rooms.map((room, num) => (
            <RoomTile
              key={`${room.request_id}_${room.code}`}
              room={room}
              position={num}
              hotel={this.props.hotel}
              onShowRoomDetails={this.onToggleRoomDetails}
            />
          ))}
        </div>
      );
    }*/
    return (
      <RoomListTwoRooms
        hotel={hotel} rooms={rooms} onToggleRoomDetails={this.onToggleRoomDetails}
        distributions={distributions} currency={userCurrency}/>
    );
  }

  renderPromoCodeAlert() {
    if (!this.state.hasInvalidPromocode) {
      return null;
    }
    return (
      <div className="promo-not-applied">
        {this.context.t('Invalid Promo Code: Enter a different code, make sure is written with CAPITAL LETTERS or continue with your booking.')}
      </div>
    );
  }

  getNewMemberDiscountPercentage() {
    //Regresa loyalty.newMemberDiscountPercentage
    //Si es 0, regresa this.props.new_member_discount_percentage ya que eso es igual a chain.Data.new_member_discount_percentage
    if (this.props.new_member_discount_percentage != null) {
      if (this.props.new_member_discount_percentage > 0) {
        return this.props.new_member_discount_percentage;
      }

      return this.props.new_member_discount_percentage_chain;
    }
    return this.props.new_member_discount_percentage_chain;
  }

  renderPromoCode() {
    const {
      hotel,
    } = this.props;
    if (!hotel || !hotel.rooms) {
      return null;
    }
    if (this.state.hasInvalidPromocode) {
      return null;
    }
    if (this.state.promocodeApplied == null || this.state.promocodeDescription == null) {
      return null;
    }
    return (
            <PromoCodeDetail code={this.state.promocodeApplied} description={this.state.promocodeDescription}/>
    );
  }

  render() {
    const {
      hotel, currentRoomId, lastRequestedInfo, distributions, chain, lang,
    } = this.props;
    if (!hotel || !hotel.rooms) {
      return null;
    }
    //console.log('000000000000000 hotel.rooms:');
    //console.log(hotel.rooms);
    const allRooms = hotel.rooms[currentRoomId];
    //console.log('---allRooms:');
    //console.log(allRooms);
    const visibleRooms = this.filterAndSortRooms(allRooms);

    /*let beMemberMessage = this.context.t('Register now and use a {coins} coins gift to apply to your booking',
      { coins: this.props.coinsForRegistering });

    if (this.props.new_member_discount_percentage_activated === true) {
      beMemberMessage = this.context.t('REGISTER NOW to get a {percentage}% discount on your 1st booking',
        { percentage: this.props.new_member_discount_percentage_chain });
    }*/

    return (
      // eslint-disable-next-line react/no-string-refs
      <main ref="RoomList">
        {/*Pidieron que no se mostrara ese banner de long stay*/}
        {/*this.props.openReservationDetails === false
        && <LongStayBanner />
        */}
        {/*Pidieron que se ocultara el HotelCardBlock*/}
        {/*this.props.openReservationDetails === false
        && <HotelCardBlock/>
        */}
        {this.props.openReservationDetails === false
              && showLoyaltyRedeem() && this.props.isLoyaltyUserLoggedIn === false
              && showLoyaltyClaimPopup()
              && <div style={{ marginTop: '40px' }}>
                  <BannerSandos4U />
                </div>
        }
        { this.props.openReservationDetails === false
          && <div className={`flex justify-end ${this.props.isDesktop ? 'mt-8 mb-2' : 'mt-4 mb-2'}`}>
            {/*Si queremos que se muestre el pop up de login de loyalty, debemos descomentar la siguiente línea*/}
            {/*showLoyaltyClaimPopup() && <ClaimPopup chainData={this.props.chainData}
            beMemberMessage={beMemberMessage}/>*/}
            <ShareWithOthers buildUrl={this.buildAvailLink} onShare={this.onShareAvailability}>
              <HotelShareCart hotel={hotel} lastRequestedInfo={lastRequestedInfo}
                distribution={distributions} chain={chain} lang={lang}/>
            </ShareWithOthers>
          </div>
        }
        {this.props.openReservationDetails === false
        && <RoomFilter rooms={allRooms} />}
        {this.props.openReservationDetails === false
        && <ViewingHotel howMany={hotel.viewing_hotel || 0} />}
        {this.state.hasInvalidPromocode && this.renderPromoCodeAlert()}
        <div className='row'>
            <div className='col-xs-12 col-md-8 removeSpaceMd8 removeSpaceXs12'
              style={
                this.props.openReservationDetails === false
                  ? {}
                  : { display: 'none' }
              }
             >
            {this.renderPromoCode()}
            {/*Pidieron que se ocultara eso que sigue*/}
            {/*<h2 className="best-rate-option-title">{this.context.t('Our best rate options for your reservation')}</h2>*/}
            {/*<BoardDetailsBlock/>*/}
            {/*showLoyaltyRedeem() && this.props.isLoyaltyUserLoggedIn === false
              && showLoyaltyClaimPopup()
              && <div className='LoyaltyLoginContainer'>
                <LoyaltyLoginBlock/>
              </div>
            */}
            {this.props.isEditingBooking === true
              && <EditModeExit/>
            }
            {this.props.isEditingBooking === true
              && <div className="select-room-to-edit-title">
                  <h2>{this.context.t('Select the room you want to edit')}</h2>
                 </div>
            }
            {this.props.isMobile === false
            && selectCurrentRoomText(this.props, this.context) !== ''
            && <div className="select-room-title">
              <h2>{selectCurrentRoomText(this.props, this.context)}</h2>
            </div>}
            {this.renderRoomTiles(visibleRooms)}
          </div>

          {(this.props.isMobile === false || (this.props.isMobile === true
          && this.props.openReservationDetails === true))
          && <div className='col-xs-12 col-md-4 removeSpaceMd4 removeSpaceXs12'>
            <ReservationDetailsBlock hotel_name={this.props.hotel.name}
              mostrarExtras={false}
              checkIn={moment(this.props.lastRequestedInfo.checkin).format('ll')}
              checkOut={moment(this.props.lastRequestedInfo.checkout).format('ll')}
              bookNowTextButton={this.context.t('Continue')}
              />
          </div>
          }
        </div>
        {this.showSelectedRoomDetailsModal(visibleRooms)}
      </main>
    );
  }
}

RoomList.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

RoomList.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  currentRoomId: state.booking.multipleRoomStep || MULTIPLE_ROOMS.FIRST,
  openReservationDetails: state.session.openReservationDetails,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  cart: state.cart,
  filterCategory: state.booking.filterCategory,
  filterOrder: state.booking.filterOrder,
  userCurrency: state.booking.filterCurrency,
  lastRequestedInfo: state.booking.last_requested_info,
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
  isEditingBooking: state.booking.isEditingBooking,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  chain: state.bookingFormState.chain,
  promoCode: state.bookingFormState.promoCode,
  distributions: state.bookingFormState.distributions,
  chainData: state.session.chainData,
  showClaimPopup: state.loyalty.showClaimPopup,
  loggedUser: state.loyalty.loggedUser,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  coinsForRegistering: state.loyalty.coinsForRegistering,
  origin: state.bookingFormState.origin,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
});

const ConnectedRoomList = connect(mapStateToProps)(RoomList);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedRoomList);
